import type { JSX, ReactNode } from "react";

import { BrandLogo } from "./BrandLogo.js";

/** Ganzseitige Meldung für Laden, Fehler und leere Zustände. */
export function StatusScreen({
  title,
  description,
  action,
  loading = false,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
  loading?: boolean;
}): JSX.Element {
  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="w-full max-w-md rounded-2xl border border-line bg-surface-raised p-8 text-center shadow-sm">
        <BrandLogo loading={loading} className="mx-auto mb-5 h-24 w-24 sm:h-28 sm:w-28" />
        <h1 className="text-lg font-semibold text-ink">{title}</h1>
        {description ? <p className="mt-2 text-sm text-ink-muted">{description}</p> : null}
        {action ? <div className="mt-6">{action}</div> : null}
      </div>
    </div>
  );
}
